import { Modal } from "react-bootstrap";
import PublicUserProfile from "../pages/PublicUserProfile";

const PublicProfileModal = ({ show, onHide, currentUser }) => {
	return (
		<Modal show={show} onHide={onHide} fullscreen>
			<Modal.Body className="p-0">
				{currentUser && <PublicUserProfile uid={currentUser.uid} onClose={onHide} />}
			</Modal.Body>
		</Modal>
	);
};

export default PublicProfileModal;
